import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import { submitSearchStoreFormAction } from 'actions/storeLocator'
import BOTStoreLocation from './BOTStoreLocation'

const withLocationFinderTitle = withProps({
  locationFinderTitle: 'No Store Located'
})

const mapStateToProps = ({ myStore: selectedStore }) => ({ selectedStore })

export default compose(
  withType({ type: 'BOTStoreLocation' }),
  connect(mapStateToProps, { findStoreHandleSubmit: submitSearchStoreFormAction }),
  withLocationFinderTitle
)(BOTStoreLocation)
